import { ConfigService } from '../../infra/config'
import { BaseRepository } from '../../infra/base.repository'
import type { Schedule } from './schedule'
import type { ImportScheduleDto } from './dto/import-schedule.dto'

export class SchedulesRepository extends BaseRepository<Schedule> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.schedulerApi + '/' + 'schedules', token, cache)
    }

    async importSchedules(dto: ImportScheduleDto[]) {
        const { json, statusCode, message } = await this.request.post(
            this.config.schedulerApi + '/schedules/import/?token=' + this.resolvedToken,
            dto,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async changed(from: Date) {
        const { json, statusCode, message } = await this.request.get(
            this.config.schedulerApi + '/schedules/changed/?from=' + from + '&token=' + this.resolvedToken,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async changeStatus(scheduleId: string, status: number) {
        const { json, statusCode, message } = await this.request.post(
            this.config.schedulerApi + '/schedules/' + scheduleId + '/status?token=' + this.resolvedToken,
            { status },
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async hollidays(year: number) {
        const { json, statusCode, message } = await this.request.get(
            this.config.schedulerApi + '/schedules/hollidays/?year=' + year + '&token=' + this.resolvedToken,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }
}
